import useUnmount from './useUnmount';

export default useUnmount;
